export const nonePartnerId = 'none';
export const modalId = 'authentication-modal';
